<form *ngIf="workerFormGroup" [formGroup]="workerFormGroup">
    <p-card tyleClass="p-card-content-pt-0 p-card-content-pb-0">
        <ng-template pTemplate="header">
            <div class="flex justify-content-center align-items-center pb-0 gap-2">
                <div class="p-card-title">Datos generales</div>
                <div class="flex-grow-1"></div>
                <div class="flex gap-2">
                    <p-tag *ngIf="totalPendingJobsLiquidation>0" [severity]="totalPendingJobsLiquidation>0?'warn':'danger'" value="{{totalPendingJobsLiquidation | currency: 'EUR' }} liquidación pendiente"></p-tag>
                    <p-tag *ngIf="totalPendingCaseServices>0" severity="warn" value="{{totalPendingCaseServices}} servicios pendientes"></p-tag>
                </div>
            </div>
        </ng-template>
        <div class="grid">
            <div class="col-1 input-field">
                <label for="thirdPartySourceId">Tipo agenda *</label>
                <p-dropdown [options]="workerTypes" formControlName="typeOfWorker" optionValue="value"
                    appendTo="body" optionLabel="name" showClear 
                    placeholder="Seleccione tipo" d-form-field-error (onChange)="onTypeOfBusinessChange()" />
            </div>
            <div class="col-1 input-field">
                <label for="thirdPartySourceId">Tipo *</label>
                <p-dropdown [options]="businessTypes" formControlName="typeOfBusiness" optionValue="value"
                    appendTo="body" optionLabel="name" showClear 
                    placeholder="Seleccione tipo" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" id="name" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="description">Nombre de contacto *</label>
                <input pInputText formControlName="description" id="description" name="description" d-form-field-error />
            </div>
            <div class="col-1 input-field">
                <label for="vatNumber">CIF/NIF</label>
                <input pInputText formControlName="vatNumber" id="vatNumber" name="vatNumber" d-form-field-error />
            </div>
            <div class="col-1 input-field">
                <label for="rating" class="mr-1">Valoración</label>
                <div class="flex h-full pt-2">
                    <p-rating formControlName="rating" id="rating" name="rating" [readonly]="true" />
                </div>
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col input-field" *ngIf="!worker.parentWorkerId">
                <label for="legalName">Razón social</label>
                <input pInputText formControlName="legalName" type="text"  id="legalName"  d-form-field-error />
            </div>
            
            <div class="col input-field" *ngIf="worker.parentWorkerId">
                <label >Supervisor</label>
                <label  style="border: 1px solid #ced4da;padding: 8px; border-radius: 5px; background-color: #dfdfdf;">{{worker.parentWorker?.name}}</label>
            </div>
            <div class="col input-field ">
                <label for="phone1">Teléfono 1</label>
                <input  id="phone1"  pInputText formControlName="phone1" name="phone1" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="phone2">Teléfono 2</label>
                <input  id="phone2"  pInputText formControlName="phone2" name="phone2" type="text" d-form-field-error />
            </div>
            <div class="col input-field ">
                <label for="email">Email</label>
                <input id="email"  pInputText formControlName="email" name="email" type="text" d-form-field-error />
            </div>
        </div>
        <div class="grid pt-2" formGroupName="address">
            <div class="col input-field col-3">
                <label for="addressLine1address">Dirección</label>
                <input id="addressLine1address"  pInputText formControlName="addressLine1" name="addressLine1address" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-3">
                <label for="zipCodeaddress">Código postal</label>
                <input id="zipCodeaddress"  pInputText formControlName="zipCode" name="zipCodeaddress" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-2">
                <label for="cityaddress">Ciudad</label>
                <input id="cityaddress"  pInputText formControlName="city" name="cityaddress" type="text" d-form-field-error />
            </div>
            <div class="col input-field col-2">
                <label for="countryRegionIdaddress">Provincia</label>
                <p-dropdown id="countryRegionIdaddress" [options]="countriesRegions" name="countryRegionIdaddress" formControlName="countryRegionId" optionValue="id"
                    [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione provincia"
                    d-form-field-error showClear />
            </div>
            <div class="col input-field col-2">
                <label for="countryCodeaddress">País</label>
                <p-dropdown  id="countryCodeaddress" [options]="countries" name="countryCodeaddress" formControlName="countryCode" optionValue="code" [filter]="true"
                    filterBy="name" optionLabel="name" placeholder="Seleccione país" d-form-field-error />
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col-1 input-field">
                <label for="active" class="mr-1">Activo</label>
                <div class="flex h-full">
                    <p-inputSwitch id="active"  name="active" formControlName="active" d-form-field-error (click)="onActiveChange()"></p-inputSwitch>
                </div>
            </div>
            <div class="col input-field col-3" *ngIf="!workerFormGroup.get('active')?.value">
                <label for="endDate">Fecha de baja *</label>
                <p-calendar id="endDate"  name="endDate" formControlName="endDate" [showIcon]="true" [readonlyInput]="true" d-form-field-error
                    [showButtonBar]="true"></p-calendar>
            </div>
            <div class="col input-field col-3" *ngIf="!workerFormGroup.get('active')?.value">
                <label for="workerEndReasonId">Razón de la baja *</label>
                <p-dropdown  id="workerEndReasonId" name="workerEndReasonId" formControlName="workerEndReasonId" [options]="workerEndReasons" optionLabel="name"
                    optionValue="id" [filter]="true" filterBy="name" placeholder="Selecciona una razón"
                    d-form-field-error />
            </div>
            <div class="col input-field col-5" *ngIf="!workerFormGroup.get('active')?.value">
                <label for="endNotes">Notas de la baja *</label>
                <textarea id="endNotes"  name="endNotes" pInputTextarea formControlName="endNotes" d-form-field-error></textarea>
            </div>
        </div>
        <div class="grid pt-2">
            <div class="col input-field col-3" *ngIf="workerFormGroup.get('typeOfBusiness')?.value=='Staff'">
                <label for="socialSecurityNumber">Número de seguridad social {{STAFF_DATA_REQUIRED ? '*' : ''}}</label>
                <input id="socialSecurityNumber" pInputText formControlName="socialSecurityNumber" name="socialSecurityNumber" type="text" d-form-field-error />

            </div>
            <div class="col input-field col-3" *ngIf="workerFormGroup.get('typeOfBusiness')?.value=='Staff'">
                <label for="professionalCategoryId">Categoría profesional {{STAFF_DATA_REQUIRED ? '*' : ''}}</label>
                <p-dropdown  id="professionalCategoryId" name="professionalCategoryId" formControlName="professionalCategoryId" 
                    [options]="professionalCategories" optionLabel="name"
                    optionValue="id" [filter]="true" filterBy="name" placeholder="Selecciona una categoría"
                    d-form-field-error />
            </div>
            
            <div class="col input-field col-3" *ngIf="workerFormGroup.get('typeOfBusiness')?.value=='Staff'">
                <label for="delegationId">Delegación {{STAFF_DATA_REQUIRED ? '*' : ''}}</label>
                <p-dropdown  id="delegationId" name="delegationId" formControlName="delegationId"
                     [options]="delegations" optionLabel="name"
                    optionValue="id" [filter]="true" filterBy="name" placeholder="Selecciona una delegación"
                    d-form-field-error />
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button *ngIf="allowWrite" label="Enviar comunicación" severity="secondary" icon="pi pi-envelope" (click)="addComunication('Mail', null, null)" />
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="preSave()"></p-button>
        </div>
    </p-card>

    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel header="Datos bancarios" [disabled]="worker.parentWorkerId != null">
            <div class="formgrid grid pt-2">
                <div class="col-2 input-field">
                    <label for="hasBankAccount">Activar</label>
                    <p-inputSwitch id="hasBankAccount" formControlName="hasBankAccount" (onChange)="onChangeHasBankAccount()"
                        d-form-field-error></p-inputSwitch>
                </div>
                <div class="col input-field" *ngIf="workerFormGroup.get('hasBankAccount')?.value"
                    formGroupName="bankAccount">
                    <label for="bankId">Banco</label>
                    <p-dropdown id="bankId" formControlName="bankId" [options]="banks" optionLabel="name" optionValue="id"
                        [filter]="true" filterBy="name" placeholder="Selecciona un banco"
                        d-form-field-error />
                </div>
                <div class="col input-field" *ngIf="workerFormGroup.get('hasBankAccount')?.value"
                    formGroupName="bankAccount">
                    <label for="accountNumber">Nº Cuenta</label>
                    <input id="accountNumber" pInputText formControlName="accountNumber" type="text" d-form-field-error />
                </div>
                <div class="col input-field" *ngIf="workerFormGroup.get('hasBankAccount')?.value"
                    formGroupName="bankAccount">
                    <label for="swift">Swift</label>
                    <input id="swift" pInputText formControlName="swift" type="text" d-form-field-error />
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Especialidades" [disabled]="!worker.id">
            <div class="flex justify-content-end">
                <p-button label="Añadir especialidad" *ngIf="allowWrite" icon="pi pi-plus"
                    (click)="editWorkerCapability(null)"></p-button>
            </div>
            <p-table styleClass="mt-4" #grid [value]="workerCapabilities" [paginator]="true" [rows]="25"
                [totalRecords]="totalCapabilitiesRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th pSortableColumn="normalServiceAllowed">Horario normal <p-sortIcon
                                field="normalServiceAllowed"></p-sortIcon></th>
                        <th pSortableColumn="guardServiceAllowed">Horario de guardia <p-sortIcon
                                field="guardServiceAllowed"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workerCapability let-columns="columns">
                    <tr (dblclick)="editWorkerCapability(workerCapability)">
                        <td>{{workerCapability.capability.name}}</td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': workerCapability.normalServiceAllowed, 'text-red-500 pi-times-circle': !workerCapability.normalServiceAllowed }"></i>
                        </td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': workerCapability.guardServiceAllowed, 'text-red-500 pi-times-circle': !workerCapability.guardServiceAllowed }"></i>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteWorkerCapability(workerCapability)"
                                    [rounded]="true" [text]="false" severity="danger"><i
                                        class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editWorkerCapability(workerCapability)"
                                    [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Zonas" [disabled]="!worker.id">
            <div class="flex align-items-center">
                <span class="mr-2">Todas las zonas</span>
                <p-inputSwitch formControlName="allZones" d-form-field-error></p-inputSwitch>
                <div class="flex-grow-1"></div>
                <p-button label="Añadir zona" *ngIf="allowWrite && !workerFormGroup.get('allZones')?.value"
                    icon="pi pi-plus" (click)="editWorkerZone(null)"></p-button>
            </div>
            <p-table *ngIf="!workerFormGroup.get('allZones')?.value" styleClass="mt-4" #grid [value]="workerZones"
                [paginator]="true" [rows]="25" [totalRecords]="totalZonesRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th pSortableColumn="normalServiceAllowed">Horario normal <p-sortIcon
                                field="normalServiceAllowed"></p-sortIcon></th>
                        <th pSortableColumn="guardServiceAllowed">Horario de guardia <p-sortIcon
                                field="guardServiceAllowed"></p-sortIcon></th>
                        <th pSortableColumn="excludedZipCodes">CP excluidos</th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workerZone let-columns="columns">
                    <tr (dblclick)="editWorkerZone(workerZone)">
                        <td>
                            <div *ngIf="workerZone.zone!=null">{{workerZone.zone.name}}</div>
                            <div *ngIf="workerZone.zone==null">Zona libre - {{workerZone.value}}</div>
                            <div class="text-danger p-ml-2" *ngIf="workerZone.isTemporary">(Asignación temporal)</div>
                        </td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': workerZone.normalServiceAllowed, 'text-red-500 pi-times-circle': !workerZone.normalServiceAllowed }"></i>
                        </td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': workerZone.guardServiceAllowed, 'text-red-500 pi-times-circle': !workerZone.guardServiceAllowed }"></i>
                        </td>
                        <td>
                            <div>{{workerZone.excludedZipCodes}}</div>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteWorkerZone(workerZone)" [rounded]="true"
                                    [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editWorkerZone(workerZone)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Disponibilidad" [disabled]="!worker.id">
            <p-card class="p-3 pt-0">
                 <ng-template pTemplate="header">
                    <div class="flex justify-content-center align-items-center pb-0 gap-2">
                        <div class="p-card-title">Horario normal</div>
                        <div class="flex-grow-1"></div>
                        <div>
                            <p-button label="Añadir horario" (click)="editTimeRange({})" styleClass="p-button-sm"
                                *ngIf="allowWrite"></p-button>
                        </div>
                    </div>
                </ng-template>
                <div>
                    <p-table #grid [value]="workerTimeRanges" [paginator]="false" [scrollable]="true"
                        scrollHeight="flex">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pSortableColumn="monday">Desde <p-sortIcon field="monday"></p-sortIcon></th>
                                <th pSortableColumn="monday">Hasta <p-sortIcon field="monday"></p-sortIcon></th>
                                <th pSortableColumn="monday">Lunes <p-sortIcon field="monday"></p-sortIcon></th>
                                <th pSortableColumn="tuesday">Martes <p-sortIcon field="tuesday"></p-sortIcon></th>
                                <th pSortableColumn="wednesday">Miércoles <p-sortIcon field="wednesday"></p-sortIcon>
                                </th>
                                <th pSortableColumn="thursday">Jueves <p-sortIcon field="thursday"></p-sortIcon></th>
                                <th pSortableColumn="friday">Viernes <p-sortIcon field="friday"></p-sortIcon></th>
                                <th pSortableColumn="saturday">Sábado <p-sortIcon field="saturday"></p-sortIcon></th>
                                <th pSortableColumn="Sunday">Domingo <p-sortIcon field="sunday"></p-sortIcon></th>
                                <th width="100"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-timeRange let-columns="columns">
                            <tr (dblclick)="editTimeRange(timeRange)">
                                <td>{{timeRangeFormat(timeRange.startHour)}}</td>
                                <td>{{timeRangeFormat(timeRange.endHour)}}</td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.monday, 'text-red-500 pi-times-circle': !timeRange.monday }"></i>
                                </td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.tuesday, 'text-red-500 pi-times-circle': !timeRange.tuesday }"></i>
                                </td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.wednesday, 'text-red-500 pi-times-circle': !timeRange.wednesday }"></i>
                                </td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.thursday, 'text-red-500 pi-times-circle': !timeRange.thursday }"></i>
                                </td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.friday, 'text-red-500 pi-times-circle': !timeRange.friday }"></i>
                                </td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.saturday, 'text-red-500 pi-times-circle': !timeRange.saturday }"></i>
                                </td>
                                <td>
                                    <i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': timeRange.sunday, 'text-red-500 pi-times-circle': !timeRange.sunday }"></i>
                                </td>
                                <td>
                                    <div class="flex gap-2 justify-content-end">
                                        <p-button *ngIf="allowDelete" (click)="deleteTimeRange(timeRange)"
                                            styleClass="p-button-xs p-button-danger"><i
                                                class="pi pi-trash"></i></p-button>
                                        <p-button *ngIf="allowWrite" (click)="editTimeRange(timeRange)"
                                            styleClass="p-button-xs"><i class="pi pi-pencil"></i></p-button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" let-columns>
                            <tr>
                                <td [attr.colspan]="9">
                                    No se han encontrado registros
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-card>            
            <p-card class="p-3" header="Guardia">
                <div>
                    <div class="flex pb-1">
                        <div class="flex align-items-center gap-2">
                            <p-inputSwitch formControlName="hasGuardShiftEnabled" d-form-field-error></p-inputSwitch>
                            Hace guardias
                        </div>
                        <div class="flex-grow-1"></div>
                        <p-button label="Asignar turno" (click)="editWorkerGuardShift()" styleClass="p-button-sm"
                            *ngIf="allowWrite && workerFormGroup.value.hasGuardShiftEnabled"></p-button>
                    </div>
                    <p-table #grid [value]="workerGuardShifts" [paginator]="false" [scrollable]="true"
                        *ngIf="workerFormGroup.value.hasGuardShiftEnabled" scrollHeight="flex">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th>Turno</th>
                                <th width="100"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-workerGuardShift let-columns="columns">
                            <tr>
                                <td>{{workerGuardShift.guardShift.name}}</td>
                                <td>
                                    <div class="flex gap-2 justify-content-end">
                                        <p-button *ngIf="allowDelete" (click)="deleteWorkerGuardShift(workerGuardShift)"
                                            styleClass="p-button-xs p-button-danger"><i
                                                class="pi pi-trash"></i></p-button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" let-columns>
                            <tr>
                                <td [attr.colspan]="2">
                                    No se han encontrado registros
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-card>
        </p-tabPanel>
        <p-tabPanel header="Sub-operarios" [disabled]="!worker.id || !!worker.parentWorkerId">
            <div class="flex justify-content-end mb-2">
                <p-button *ngIf="allowWrite" label="Añadir suboperario" styleClass="ml-2" icon="pi pi-plus"
                    (click)="addSubWorker()" />
            </div>
            <p-table styleClass="mt-4" [value]="subWorkers" [paginator]="true" [rows]="25"
                [totalRecords]="totalSubWorkersRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-subWorker let-columns="columns">
                    <tr (dblclick)="editSubWorker(subWorker)">
                        <td>{{subWorker.name}}</td>

                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowWrite" (click)="editSubWorker(subWorker)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Vehículos" [disabled]="!worker.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Asignar vehículo" (click)="assignVehicle({})" styleClass="p-button-sm"
                    *ngIf="allowWrite"></p-button>
                <p-button label="Nuevo vehículo" (click)="editVehicle({})" styleClass="p-button-sm ml-2"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="vehicles" [paginator]="true" [rows]="25"
                [totalRecords]="totalVehiclesRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Matrícula <p-sortIcon field="plate"></p-sortIcon></th>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th pSortableColumn="name">Desde <p-sortIcon field="fromDate"></p-sortIcon></th>
                        <th pSortableColumn="name">Hasta <p-sortIcon field="toDate"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-vehicle let-columns="columns">
                    <tr (dblclick)="assignVehicle(vehicle)">
                        <td>{{vehicle.vehicle.plate}}</td>
                        <td>{{vehicle.vehicle.name}}</td>
                        <td>{{vehicle.fromDate | date:'dd/MM/yy'}}</td>
                        <td>{{vehicle.toDate | date:'dd/MM/yy'}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteVehicle(vehicle)" [rounded]="true"
                                    styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="assignVehicle(vehicle)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="2">
                            No se han encontrado vehículos
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Equipamiento" [disabled]="!worker.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Añadir equipamiento" (click)="editEquipment({})" styleClass="p-button-sm"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="workerEquipments" [paginator]="true" [rows]="25"
                [totalRecords]="totalEquipmentsRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th pSortableColumn="name">Notas <p-sortIcon field="notes"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-equipment let-columns="columns">
                    <tr (dblclick)="editEquipment(equipment)">
                        <td>{{equipment.equipment.name}}</td>
                        <td>{{equipment.notes}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteWorkerEquipment(equipment)"
                                    [rounded]="true" styleClass="p-button-xs p-button-danger"><i
                                        class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editEquipment(equipment)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="3">
                            No se han encontrado equipamientos
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Configuración" [disabled]="!worker.id">
            <p-card header="Acceso a la aplicación">
                <div class="grid">
                    <div class="col-2 input-field">
                        <label for="enableAccess">Activar acceso</label>
                        <p-inputSwitch formControlName="enableAccess" (onChange)="onEnableAccessChange()"
                            d-form-field-error></p-inputSwitch>
                    </div>
                    <div class="col-2 input-field" formGroupName="user" *ngIf="workerFormGroup.value.enableAccess">
                        <label for="userName">Nombre de usuario</label>
                        <input pInputText id="username" formControlName="userName" type="text" d-form-field-error />
                    </div>
                    <div class="col-2 input-field" formGroupName="user" *ngIf="workerFormGroup.value.enableAccess">
                        <label for="roleId">Perfil</label>
                        <p-dropdown id="roleId" [options]="roles" formControlName="roleId" [required]="true" optionValue="id"
                            filterBy="title" optionLabel="title" placeholder="Seleccione perfil" d-form-field-error />
                    </div>
                    <div class="col-2 input-field"
                        *ngIf="workerFormGroup.value.enableAccess && workerFormGroup.value.user!=null && worker.userId==null"
                        formGroupName="user">
                        <label for="password">Password</label>
                        <p-password id="password" type="password" formControlName="password" autocomplete="new-password"
                            [toggleMask]="true" d-form-field-error></p-password>
                    </div>
                    <div class="col-4 input-field" *ngIf="worker.userId && workerFormGroup.value.enableAccess">
                        <label>&nbsp;</label>
                        <p-button label="Cambiar contraseña" icon="pi pi-send" styleClass="p-button-secondary"
                            (click)="changePassword()"></p-button>
                    </div>
                </div>
            </p-card>
            <p-card header="Dirección de salida">
                <div class="grid">
                    <div class="col-4 input-field">
                        <label for="usePrincipalAddressAsWorkStart">Usar misma dirección fiscal</label>
                        <p-inputSwitch id="usePrincipalAddressAsWorkStart" formControlName="usePrincipalAddressAsWorkStart"
                            (onChange)="onEnableUsePrincipalAddressAsWorkStartChange()"
                            d-form-field-error></p-inputSwitch>
                    </div>
                    <div class="grid pt-2 col-12" formGroupName="workStartAddress"
                        *ngIf="!workerFormGroup.value.usePrincipalAddressAsWorkStart">
                        <div class="col input-field col-3">
                            <label for="addressLine1">Dirección *</label>
                            <input id="addressLine1" name="addressLine1" pInputText formControlName="addressLine1" type="text" d-form-field-error />
                        </div>
                        <div class="col input-field col-2">
                            <label for="zipCode">Código postal</label>
                            <input id="zipCode" name="zipCode" pInputText formControlName="zipCode" type="text" d-form-field-error />
                        </div>
                        <div class="col input-field col-3">
                            <label for="city">Ciudad</label>
                            <input id="city"  name="city" pInputText formControlName="city" type="text" d-form-field-error />
                        </div>
                        <div class="col input-field col-2">
                            <label for="countryRegionIdaddress">Provincia</label>
                            <p-dropdown id="countryRegionIdaddress" [options]="countriesRegions" name="countryRegionIdaddress" formControlName="countryRegionId" optionValue="id"
                                [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione provincia"
                                d-form-field-error showClear />
                        </div>
                        <div class="col input-field col-2">
                            <label for="countryCode">País</label>
                            <p-dropdown id="countryCode" name="countryCode" [options]="countries" formControlName="countryCode" [required]="true"
                                optionValue="code" [filter]="true" filterBy="name" optionLabel="name"
                                placeholder="Seleccione país" d-form-field-error />
                        </div>
                    </div>
                </div>
            </p-card>
            <p-card header="Agenda">
                <div class="grid">
                    <div class="col input-field">
                        <label for="sendCaseServiceByEmail" >Enviar citas por email</label>
                        <div class="flex h-full">
                            <p-inputSwitch name="sendCaseServiceByEmail" id="sendCaseServiceByEmail" formControlName="sendCaseServiceByEmail" d-form-field-error></p-inputSwitch>
                        </div>
                    </div>
                    <div class="col input-field3">
                        <label for="hoursCaseService">Duración media de cita (horas)</label>
                        <input id="hoursCaseService"  pInputText formControlName="hoursCaseService" name="hoursCaseService" type="number" d-form-field-error />
                    </div>
                    <div class="col input-field">
                        <label for="manageYourAppointments">Gestiona su agenda</label>
                        <p-inputSwitch id="manageYourAppointments" name="manageYourAppointments" formControlName="manageYourAppointments" d-form-field-error></p-inputSwitch>
                    </div>
                    <div class="col input-field" *ngIf="workerFormGroup.get('manageYourAppointments')?.value">
                        <label for="maxUnconfirmedServices">Nº máximo de servicios sin confirmar</label>
                        <input id="maxUnconfirmedServices" name="maxUnconfirmedServices" pInputText type="number" formControlName="maxUnconfirmedServices" id="maxUnconfirmedServices"
                            d-form-field-error />
                    </div>
                    <div class="col input-field">
                        <label for="allowRegisterServiceOffTheClock" >Permitir registro de servicios fuera de hora</label>
                        <div class="flex h-full">
                            <p-inputSwitch name="allowRegisterServiceOffTheClock" id="allowRegisterServiceOffTheClock" formControlName="allowRegisterServiceOffTheClock" d-form-field-error></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </p-card>
            <p-card header="Facturación" *ngIf="!worker.parentWorkerId">
                <div class="grid">
                    <div class="col-2 input-field">
                        <label for="hasSubmitInvoice">Presenta factura</label>
                        <p-inputSwitch id="hasSubmitInvoice" name="hasSubmitInvoice" formControlName="hasSubmitInvoice" d-form-field-error></p-inputSwitch>
                    </div>
                    <div class="col-4 input-field">
                        <label for="paymentMethodId">Método de pago</label>
                        <p-dropdown id="paymentMethodId"  [options]="paymentMethods" formControlName="paymentMethodId" name="paymentMethodId" optionValue="id"
                          [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione método de pago"
                          d-form-field-error />
                    </div>
                    <div class="col-2 input-field">
                        <label for="paymentDay">Dia de pago factura</label>
                        <input id="paymentDay" pInputText type="number" id="paymentDay" name="paymentDay" formControlName="paymentDay" d-form-field-error />
                    </div>
                </div>
            </p-card>
        </p-tabPanel>
        <p-tabPanel header="Calendario" [disabled]="!worker.id">
            <div class="grid justify-content-center">
                <div class="col-5 input-field">
                    <p-dropdown formControlName="calendarId" [options]="calendars" optionLabel="name" optionValue="id"
                        [filter]="true" filterBy="name" (onChange)="onChangeCalendar($event)"
                        placeholder="Seleccione un calendario" d-form-field-error />
                </div>
            </div>
            <p-card class="p-3">
                <app-calendar-year [events]="calendarEvents" [workerCalendarEvents]="workerCalendarEvents"
                    (onDayClick)="daySelected($event)" 
                    (onDateRangeSelect)="daySelected($event)"
                    (onMultiDaySelectEnd)="daySelected($event)"
                    (onYearChange)="yearChanged($event)"></app-calendar-year>
            </p-card>

        </p-tabPanel>
        
        <p-tabPanel header="Conceptos facturables" [disabled]="!worker.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Nuevo concepto" (click)="editBillableItem({})" styleClass="p-button-sm ml-2"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="billableItems" [paginator]="true" [rows]="25"
                [totalRecords]="totalBillableItemsRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon></th>
                        <th pSortableColumn="startDate">Desde <p-sortIcon field="startDate"></p-sortIcon></th>
                        <th pSortableColumn="endDate">Hasta <p-sortIcon field="endDate"></p-sortIcon></th>
                        <th pSortableColumn="isPayToWorker">Cobro/Cargo <p-sortIcon field="isPayToWorker"></p-sortIcon></th>
                        <th style="text-align: right;">Cantidad</th>
                        <th style="text-align: right;">Precio</th>
                        <th style="text-align: right;">Impuestos</th>
                        <th style="text-align: right;">Total</th>
                        <th style="text-align: right;">Activo</th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-billableItem let-columns="columns">
                    <tr (dblclick)="editBillableItem(billableItem)">
                        <td>{{billableItem.description}}</td>
                        <td>{{billableItem.startDate | date:'dd/MM/yy'}}</td>
                        <td>{{billableItem.endDate | date:'dd/MM/yy'}}</td>
                        <td>{{billableItem.isPayToWorker?"Se paga al operario":"Se cobra al operario"}}</td>
                        <td style="text-align: right;">
                            {{billableItem.quantity}}
                        </td>
                        <td style="text-align: right;">
                            {{billableItem.price | currency: 'EUR'}}
                        </td>
                        <td style="text-align: right;">
                            {{'('+billableItem.tax.name+')'}} {{getTax(billableItem) | currency: 'EUR' }}
                        </td>
                        <td style="text-align: right;">
                            {{getTotalBillableItem(billableItem) | currency: 'EUR' }}
                        </td>
                        <td style="text-align: right;">
                            <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': billableItem.active, 'text-red-500 pi-times-circle': !billableItem.active }"></i>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">

                                <p-button *ngIf="allowDelete && billableItem.workerVehicleId == null"
                                    (click)="deleteBillableItem(billableItem)" [rounded]="true"
                                    styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite && billableItem.workerVehicleId == null"
                                    (click)="editBillableItem(billableItem)" [rounded]="true" [text]="false"><i
                                        class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="2">
                            No se han encontrado conceptos facturables
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        
        <p-tabPanel header="Notas" [disabled]="!worker.id">
            <div class="flex">
                <div class="col-6">
                    <div class="mb-1"><label>Notas:</label></div>
                    <p-editor formControlName="notes" [style]="{ height: '320px' }">
                        <ng-template pTemplate="header">
                            <span class="ql-formats">
                                <button type="button" class="ql-bold" aria-label="Negrita"></button>
                                <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                                <button type="button" class="ql-underline" aria-label="Subrayado"></button>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-color" aria-label="Color"></select>
                                <select class="ql-background" aria-label="Color de fondo"></select>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-list" value="ordered" aria-label="Lista de números"></button>
                                <button type="button" class="ql-list" value="bullet" aria-label="Lista de puntos"></button>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-link" aria-label="Enlace"></button>
                                <select class="ql-align" aria-label="Alineación"></select>
                            </span>
                        </ng-template>
                    </p-editor>
                </div>
                <div class="col-6">
                    <div class="mb-1"><label>Notas económicas:</label></div>
                    <p-editor formControlName="economicNotes" [style]="{ height: '320px' }">
                        <ng-template pTemplate="header">
                            <span class="ql-formats">
                                <button type="button" class="ql-bold" aria-label="Negrita"></button>
                                <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                                <button type="button" class="ql-underline" aria-label="Subrayado"></button>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-color" aria-label="Color"></select>
                                <select class="ql-background" aria-label="Color de fondo"></select>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-list" value="ordered" aria-label="Lista de números"></button>
                                <button type="button" class="ql-list" value="bullet" aria-label="Lista de puntos"></button>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-link" aria-label="Enlace"></button>
                                <select class="ql-align" aria-label="Alineación"></select>
                            </span>
                        </ng-template>
                    </p-editor>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Documentos" [disabled]="!worker.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Nuevo documento" (click)="editFile()" styleClass="p-button-sm"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table #grid [value]="files" [paginator]="true" [scrollable]="true" scrollHeight="flex" [paginator]="true"
                [rows]="25" [totalRecords]="totalWorkersFiles" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th>Vencimiento </th>
                        <th>Nombre </th>
                        <th>Fichero </th>
                        <th>BlockChain </th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file let-columns="columns">
                    <tr (dblclick)="editFile(file)">
                        <td>
                            <span *ngIf="today <= file.expirationDate"> {{file.expirationDate |
                                date:'dd/MM/yyyy'}}</span>
                            <span class="text-danger" *ngIf="today > file.expirationDate"> {{file.expirationDate |
                                date:'dd/MM/yyyy'}}</span>
                        </td>
                        <td>{{file.name}}</td>
                        <td>{{file.file.fileName}}</td>
                        <td>
                            <p-tag icon="pi pi-check-circle" severity="success"
                                value="{{file.file.hash}} - {{file.file.hashDate | date:'dd/MM/yyyy HH:mm:ss'}}" />
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteFile(file)"
                                    styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="downloadFile(file.fileId)"
                                    icon="pi pi-cloud-download" styleClass="p-button-xs"> </p-button>
                                <p-button *ngIf="allowWrite" (click)="editFile(file)" styleClass="p-button-xs"><i
                                        class="pi pi-pencil"></i></p-button>

                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Baremos" [disabled]="!worker.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Añadir baremo" (click)="addRate({})" styleClass="p-button-sm"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="rates" [paginator]="true" [rows]="25" [totalRecords]="totalRatesRecords"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="rate.name">Baremo <p-sortIcon field="rate.name"></p-sortIcon></th>
                        <th pSortableColumn="normalServiceAllowed">Horario normal <p-sortIcon
                                field="normalServiceAllowed"></p-sortIcon></th>
                        <th pSortableColumn="guardServiceAllowed">Horario de guardia <p-sortIcon
                                field="guardServiceAllowed"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workerRate let-columns="columns">
                    <tr (dblclick)="addRate(workerRate)">
                        <td>{{workerRate.rate?.name}}</td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': workerRate.normalServiceAllowed, 'text-red-500 pi-times-circle': !workerRate.normalServiceAllowed }"></i>
                        </td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': workerRate.guardServiceAllowed, 'text-red-500 pi-times-circle': !workerRate.guardServiceAllowed }"></i>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                
                                <p-button *ngIf="allowDelete" (click)="deleteRate(workerRate)" [rounded]="true"  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="addRate(workerRate)" styleClass="p-button-xs" [rounded]="true"><i
                                    class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="2">
                            No se han encontrado resultados
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <p-tabPanel header="Embargos" [disabled]="!worker.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Nuevo embargo" (click)="editWorkerSeizure({})" styleClass="p-button-sm ml-2"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="workerSeizures" [paginator]="true" [rows]="25"
                [totalRecords]="totalWorkerSeizuresRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="isClose">Estado <p-sortIcon field="isClose"></p-sortIcon></th>
                        <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                        <th pSortableColumn="caseNumber">Nº de expediente <p-sortIcon field="caseNumber"></p-sortIcon></th>
                        <th style="text-align: right;" pSortableColumn="ammount">Importe <p-sortIcon field="ammount"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workerSeizure let-columns="columns">
                    <tr (dblclick)="editWorkerSeizure(workerSeizure)">
                        <td>

                            <span class="p-tag"
                            [class.p-tag-danger]="!workerSeizure.isClosed" [class.p-tag-success]="workerSeizure.isClosed">
                                <span class="p-tag-label">{{workerSeizure.isClosed?"Cerrado":"Abierto"}}</span>
                            </span>
                        </td>                        
                        <td>{{workerSeizure.date | date:'dd/MM/yy'}}</td>
                        <td>{{workerSeizure.caseNumber}}</td>
                        <td style="text-align: right;">
                            {{workerSeizure.ammount | currency: 'EUR'}}
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete"
                                    (click)="deleteWorkerSeizure(workerSeizure)" [rounded]="true" styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite"
                                    (click)="editWorkerSeizure(workerSeizure)" [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="2">
                            No se han encontrado embargos
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <p-tabPanel header="Contratos" *ngIf="workerFormGroup.get('typeOfBusiness')?.value=='Staff'">
            <div class="flex justify-content-end mb-2">
                <p-button *ngIf="allowWrite" label="Añadir contrato" styleClass="ml-2" icon="pi pi-plus"
                    (click)="editWorkerContract(null)" />
            </div>
            <p-table styleClass="mt-4" [value]="workerContracts" [paginator]="true" [rows]="25" [lazy]="true" (onLazyLoad)="loadWorkerContracts($event)"
                [totalRecords]="totalWorkerContractsRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th >Tipo </th>
                        <th >Horas semanales </th>
                        <th >Salario bruto anual </th>
                        <th >Coste hora </th>
                        <th >Convenio </th>
                        <th >Fecha inicio </th>
                        <th >Fecha fin </th>
                        <th >Activo <p-sortIcon field="name"></p-sortIcon></th>

                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workerContract let-columns="columns">
                    <tr (dblclick)="editWorkerContract(workerContract)">
                        <td>{{workerContract.typeContract?.name}}</td>
                        <td>{{workerContract.hours}}h</td>
                        <td>{{workerContract.salary | currency:'EUR':'symbol':'1.2-2'}}</td>
                        <td>{{workerContract.hourlyCost | currency:'EUR':'symbol':'1.2-2'}}</td>
                        <td>{{workerContract.colectiveAgreement?.name}}</td>
                        <td>{{workerContract.startDate | date:'dd/MM/yyyy'}}</td>
                        <td>{{workerContract.endDate | date:'dd/MM/yyyy'}}</td>
                        <td>
                            <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': workerContract.active, 'text-red-500 pi-times-circle': !workerContract.active }"></i></td>

                        <td>
                            <div class="flex gap-2 justify-content-end">
                                
                                <p-button *ngIf="allowDelete" (click)="deleteWorkerContract(workerContract)" [rounded]="true"
                                    [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editWorkerContract(workerContract)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</form>

<p-dialog header="Modificar contraseña" [modal]="true" [(visible)]="visibleChangePass" [style]="{ width: '300px' }">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="password" class="p-col-4">Cambiar contraseña</label>
            <input pPassword type="password" id="password" class="flex-auto" autocomplete="off" [(ngModel)]="password"
                aria-label="Constraseña" />
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cerrar" icon="pi pi-times" styleClass="p-button-secondary"
            (click)="visibleChangePass = false"></p-button>
        <p-button label="Guardar" icon="pi pi-save" (click)="saveChangePassword(password)"></p-button>
    </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>